import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExchangeRateInformationComponent } from "./exchange-rate-information.component";
import { MatTableModule } from "@angular/material/table";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BtnModule } from "../../../../libraries/ui_button/btn.module";
import {NotificationModule} from "../../../../libraries/component/notification/notification.module";

@NgModule({
    imports: [
        BtnModule,
        CommonModule,
        FontAwesomeModule,
        MatTableModule,
        NotificationModule,
    ],
    exports: [ExchangeRateInformationComponent],
    declarations: [ExchangeRateInformationComponent],
})
export class ExchangeRateInformationModule { }
